module.exports = __webpack_public_path__ + "img/icon_help.c00768ed.svg";